// Module
var code = "<span class=\"option\"\n      ng-repeat=\"option in options()\" space-between\n      ng-click=\"selectingValue(option)\"\n      ng-class=\"{selected: option.selected}\">\n    <div><i ng-class=\"[option.icon]\"></i></div>\n    <div ng-bind=\"option.label\"></div>\n</span>\n";
// Exports
module.exports = code;